var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loaded)?_vm._t("default"):_c('div',_vm._l((_vm.count),function(index){return _c('div',{key:index,staticClass:"bone"})}),0)],2)}
var staticRenderFns = []

export { render, staticRenderFns }